import { AbstractJSONModel } from "./master-model";
export interface IPosition {
  id: number;
  name: string;
  position_category_id: number;
  must_supervise: boolean;
  created_at: Date;
  updated_at: Date;
  is_active: boolean;
}

export interface IPositionPost {
  name: string;
  position_category_id: number;
  must_supervise: boolean;
  is_active: boolean;
}

export interface IPositionPut {
  id: number;
  name: string;
  position_category_id: number;
  must_supervise: boolean;
  is_active: boolean;
}

export class Position extends AbstractJSONModel implements IPosition {
  public id = -1;
  public name = "";
  public position_category_id = -1;
  public must_supervise = false;
  public is_active = false;

  public created_at: Date = new Date();

  public updated_at: Date = new Date();
  public salary_stillingskategori: number | undefined = undefined;

  public convertToPostObject(): IPositionPost {
    const p: IPositionPost = Object.assign({});
    p.must_supervise = this.must_supervise;
    p.name = this.name;
    p.position_category_id = this.position_category_id;
    p.is_active = this.is_active;
    return p;
  }

  public convertToPutObject(): IPositionPut {
    const p: IPositionPut = Object.assign({});
    p.id = this.id;
    p.must_supervise = this.must_supervise;
    p.name = this.name;
    p.position_category_id = this.position_category_id;
    p.is_active = this.is_active;
    return p;
  }

  equals(other: IPosition): boolean {
    return other.id === this.id;
  }
}
